import React, {useContext, useEffect} from "react";
import {CreateDeliveryContext} from "../../CreateDeliveryRequest";
import {
    CreditLabel,
    PickupInformationContainer,
    PickupInformationHeader,
    PickupInformationTitle
} from "./PickupInformation.styles";
import {CircleMarker} from "../../../_defaultComponents/CircleMarker/CircleMarker";
import {InputRow} from "../inputRow/InputRow";

import SubCompanyInput from "./subCompanyInput/SubCompanyInput";
import {Form, Input} from "antd";
import {useTranslation} from "react-i18next";
import {UploadExcelFromTemplate} from "./components/UpdateExcelFromTemplate";
import {useStore} from "../../../../hooks/useStore";
import {formatNumberString} from "../../../../utils/helpers";

export const PickupInformation = () => {
    const {t} = useTranslation(["newRequest", "subcompanyDetail"]);
    const {
        createDeliveryRequestForm,
        selectedCompany,
        selectedSubCompany,
        handleSelectCompany,
        handleSelectPickupPoint,
        getError
    } = useContext(CreateDeliveryContext);

    const subCompanyOptionFilter = subCompany => {
        if (!selectedCompany) return true;
        return subCompany.companyId === selectedCompany._id.toString();
    };

    return (
        <PickupInformationContainer>
            <PickupInformationHeader>
                <CircleMarker color="red">1</CircleMarker>
                <PickupInformationTitle>
                    {t("newRequest.fields.pickUp", {ns: "newRequest"})}
                </PickupInformationTitle>
                {selectedSubCompany && <UploadExcelFromTemplate />}
            </PickupInformationHeader>
            <InputRow
                title={t("fields.address", {ns: "common"})}
                content={
                    <>
                        <Form
                            autoComplete="off"
                            labelCol={{span: 24}}
                            wrapperCol={{span: 24}}
                            scrollToFirstError
                            data-testid="pickupForm"
                        >
                            {/* TODO : SHOW ONLY ADMIN */}
                            {/*   <CompanyInput
                            data-testid="PickupInformationContainer_companyInput"
                            onChange={value => handleSelectCompany({companyId: value})}
                        /> */}

                            <Form.Item
                                validateStatus={
                                    getError(`pickupInfos.0.pickupPointId`) ? "error" : "success"
                                }
                                help={getError(`pickupInfos.0.pickupPointId`)}
                                style={{marginBottom: "0px"}}
                            >
                                <SubCompanyInput
                                    data-testid="PickupInformationContainer_subCompanyInput"
                                    onChange={value =>
                                        handleSelectPickupPoint({subCompanyId: value})
                                    }
                                    mb={getError(`pickupInfos.0.pickupPointId`) ? "0px" : "20px"}
                                    initialCall={true}
                                    disabled={false}
                                    optionFilter={subCompanyOptionFilter}
                                    loadWithDelay={500}
                                    value={selectedSubCompany?._id}
                                />
                            </Form.Item>
                            {selectedSubCompany &&
                            Number.isFinite(selectedSubCompany?.credit) &&
                            selectedSubCompany?.credit !== 9999999 &&
                            typeof selectedSubCompany?.credit === "number" ? (
                                <Form.Item>
                                    <h5>Bakiye</h5>
                                    <CreditLabel>
                                        {formatNumberString(selectedSubCompany?.credit)}₺
                                    </CreditLabel>
                                </Form.Item>
                            ) : (
                                <></>
                            )}
                            {selectedSubCompany ? (
                                <>
                                    <h5>{t("fields.address", {ns: "common"})}</h5>
                                    <Input
                                        value={selectedSubCompany?.address || ""}
                                        disabled
                                        style={{marginBottom: "20px"}}
                                    />{" "}
                                </>
                            ) : (
                                <> </>
                            )}
                        </Form>
                    </>
                }
            />
            {selectedSubCompany ? (
                <InputRow
                    title={t("newRequest.fields.sender", {ns: "newRequest"})}
                    content={
                        <>
                            <Form
                                autoComplete="off"
                                labelCol={{span: 24}}
                                wrapperCol={{span: 24}}
                                scrollToFirstError
                                data-testid="receviverForm"
                            >
                                <h5>{t("fields.authorizedPerson", {ns: "common"})}</h5>
                                <Input
                                    value={selectedSubCompany?.authorizedPerson}
                                    disabled
                                    style={{marginBottom: "20px"}}
                                />

                                <h5>{t("fields.authorizedPhone", {ns: "common"})}</h5>
                                <Input value={selectedSubCompany?.authorizedPhone} disabled />
                            </Form>
                        </>
                    }
                />
            ) : (
                <></>
            )}
        </PickupInformationContainer>
    );
};
